export const DEFAULT_ROWS_COUNT = 20;
export const MOBILE_DEFAULT_ROWS_COUNT = 10;
export const PLACEHOLDERS_COUNT = 3;
